<template>
  <md-whiteframe md-tag="section" class="card" md-elevation="8">
    <md-card>

      <md-card-header>
        <md-card-header-text>
          <md-layout>
            <md-layout class="md-title">
              <translate tag="div" class="order-id">Order: #%{ orderId }</translate>

              <md-button id="download-pdf-button" @click.native="downloadPdf()" class="md-icon-button">
                <md-icon>file_download<md-tooltip md-direction="right"><translate>Download PDF</translate></md-tooltip></md-icon>
              </md-button>
              <md-button id="print-pdf-button" @click.native="printPdf()" class="md-icon-button">
                <md-icon>print<md-tooltip md-direction="right"><translate>Print order details</translate></md-tooltip></md-icon>
              </md-button>

            </md-layout>
            <md-layout class="md-subheading" md-align="end">{{ order.date }}</md-layout>
          </md-layout>
        </md-card-header-text>
      </md-card-header>
      <md-card-content>

        <md-layout md-gutter="8">
          <md-layout md-flex="5" md-flex-medium="10"><translate>Depot:</translate></md-layout>
          <md-layout md-flex="25"><span class="text">{{ order.customer }}</span></md-layout>
          <md-layout md-flex="5" md-flex-medium="10"><translate>Address:</translate></md-layout>
          <md-layout><span class="text">{{ order.address.street }}</span></md-layout>
          <md-layout md-align="end" class="md-title"><translate>TOTAL: %{ order.totalPrice } € (incl. VAT)</translate></md-layout>
        </md-layout>

        <md-layout md-gutter="8">
          <md-layout md-flex="5" md-flex-medium="10"><translate>Client:</translate></md-layout>
          <md-layout md-flex="25"><span class="text">{{ order.name }}</span></md-layout>
          <md-layout md-flex="5" md-flex-medium="10"></md-layout>
          <md-layout><span class="text">{{ order.address.postcode }} {{ order.address.city }}, {{ order.address.country }}</span></md-layout>
          <md-layout md-align="end"><translate :translate-n="order.totalItems" translate-plural="%{ order.totalItems } items">%{ order.totalItems } item</translate></md-layout>
        </md-layout>

        <md-layout md-gutter="8">
          <md-layout md-align="end">
            <md-button id="show-details-button" class="show-button md-raised" @click.native="toggle()">
              <span>{{ showMsg }}</span>
            </md-button>
          </md-layout>
        </md-layout>

      </md-card-content>

      <md-card-expand class="order-expand">
        <md-card-actions class="details-button">
          <span style="flex: 1"></span>
          <md-button class="md-icon-button" md-expand-trigger>
            <md-icon>keyboard_arrow_down</md-icon>
          </md-button>
        </md-card-actions>

        <md-card-content>
          <md-card class="content">
            <md-table >
              <md-table-header>
                <md-table-row>
                  <md-table-head><translate>Product</translate></md-table-head>
                  <md-table-head><translate>Quantity</translate></md-table-head>
                  <md-table-head><translate>Price (incl. VAT)</translate></md-table-head>
                </md-table-row>
              </md-table-header>

              <md-table-body>
                <md-table-row v-for="(product, index) in order.products" :key="index">
                  <md-table-cell class="column">{{ product.name }}</md-table-cell>
                  <md-table-cell class="column">{{ product.quantity }}</md-table-cell>
                  <md-table-cell class="column">{{ (product.quantity * product.price).toFixed(2) }} €</md-table-cell>
                </md-table-row>
              </md-table-body>
            </md-table>
          </md-card>
        </md-card-content>
      </md-card-expand>

    </md-card>
  </md-whiteframe>
</template>

<script>
import OrderPdf from '../common/OrderPdf'

export default {
  name: 'order-card',
  data () {
    return {
      show: true
    }
  },
  props: [ 'order' ],
  computed: {
    showMsg () {
      if (this.show) {
        return this.$gettext('Show details')
      } else {
        return this.$gettext('Hide details')
      }
    },
    orderId () {
      return ('000000' + this.order.orderId).slice(-6)
    }
  },
  methods: {
    toggle () {
      this.show = !this.show
      this.$el.querySelector('.order-expand').classList.toggle('md-active')
    },
    downloadPdf () {
      OrderPdf.downloadPdf(this.order, this)
    },
    printPdf () {
      OrderPdf.printPdf(this.order, this)
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: left;
}
.details-button {
  display: none;
}
.order-id {
  padding-top: 4px;
  margin-right: 8px;
}
.show-button {
  margin: 0px;
  margin-top: 10px;
  color: #3f51b5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/order/Card.vue